var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchEx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4 1.40002L7.79999 6L12.4 10.6L11 12L5 6L11 0L12.4 1.40002Z",
    fill: "#dddddd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.000396606 10.6L4.6004 6L0.000395802 1.40003L1.40039 5.24537e-07L7.40039 6L1.40039 12L0.000396606 10.6Z",
    fill: "#dddddd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchEx);
export default __webpack_public_path__ + "static/media/search_ex.c83179ef.svg";
export { ForwardRef as ReactComponent };